import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { MatDialogModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsModule } from '@ngxs/store';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Authguard, AuthguardService } from './helper';
import { Loading } from './loading';
import {
  HomeModule, LoginLayoutComponent,
  P401Component, P403Component, P404Component, P500Component
} from './views';
import { JobMergeState } from './views/home/job/job-merge-customer/state/job-merge.state';
import { PMDetailState } from './views/home/preventive-maintenance/state/pm-detail.state';




@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,
    LoginLayoutComponent,
    P401Component,
    P403Component,
    P404Component,
    P500Component,    
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    HomeModule,
    MatDialogModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: ( createTranslateLoader ),
        deps: [ HttpClient ]
      }
    }),
    NgbModule.forRoot(),
    NgxsModule.forRoot([
      PMDetailState,
      JobMergeState
    ]),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    // NgxsLoggerPluginModule.forRoot({
    //   collapsed: true,
    //   logger: console
    // }),

  ],
  providers: [
    Authguard,
    AuthguardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Loading,
      multi: true
    }
  ]
})

export class AppModule { }

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/app.module.ts